// extracted by mini-css-extract-plugin
module.exports = {"container":"e_f1","textBadge":"e_g1","buttonBlock":"e_h1"};